import { api } from '../../api/api';
import apiError from '../../api/api-error';

// initial state
const state = {
   rec:null,
};

// getters
const getters = {
};

// actions
const actions = {
   ZONING_HIGHLIGHT:(context, {})=>{
      const obj = {
         source:'scoutred',
         sourceLayer:'zoning',
         id:state.rec.id,
      };
      context.commit('MAP_FEATURE_ACTIVE_SET', obj);
   },
   ZONING_HIGHLIGHT_CLEAR:(context, {})=>{
      context.commit('MAP_FEATURE_ACTIVE_SET', null);
   },
   ZONING_GET:(context, {id})=>{
      return new Promise((resolve, reject)=>{
         api.get('/api/zoning/'+ id)
            .then(function (res) {
               context.commit('ZONING_SET', {rec: res.data});
               resolve();
            })
            .catch(function (error) {
               context.commit('ERROR_MESSAGE_SET',{message:apiError.message('zoning',error)});
               reject(apiError.message('zoning',error));
            });
      });
   },
   ZONING_REFERENCE_ADD:async (context, {id, reference})=>{
      const add = {...reference, zoningId:Number(id)};
      const res = await api.post('/api/zoning/'+id+'/references', add);
      context.dispatch('ZONING_GET',{id});
   },
   ZONING_REFERENCE_DELETE:async (context, {id, referenceId})=>{
      const res = await api.delete('/api/zoning/'+id+'/references/'+referenceId);
      context.dispatch('ZONING_GET',{id});
   },
   ZONING_REFERENCE_SAVE:async (context, {id, reference, referenceId})=>{
      const res = await api.put('/api/zoning/'+id+'/references/'+referenceId, reference);
      context.dispatch('ZONING_GET',{id});
   },
   ZONING_REGULATION_ADD:async (context, {id, regulation})=>{
      const add = {...regulation, zoningId:Number(id)};
      const res = await api.post('/api/zoning/'+id+'/regulations', add);
      context.dispatch('ZONING_GET',{id});
   },
   ZONING_REGULATION_DELETE:async (context, {id, regulationId})=>{
      const res = await api.delete('/api/zoning/'+id+'/regulations/'+regulationId);
      context.dispatch('ZONING_GET',{id});
   },
   ZONING_REGULATION_SAVE:async (context, {id, regulation, regulationId})=>{
      const res = await api.put('/api/zoning/'+id+'/regulations/'+regulationId, regulation);
      context.dispatch('ZONING_GET',{id});
   },
   ZONING_SAVE:async (context, {id, rec})=>{
      const res = await api.put('/api/zoning/'+ id, rec);
      context.commit('ZONING_SET',{rec:rec});
   },
   ZONING_ZOOM_TO:(context, coords)=>{
      let centerX, centerY;

      if(coords){
         centerX = coords.lng; 
         centerY = coords.lat;
      } else {
         if (!state.rec || !state.rec.bounds || !state.rec.bounds.bbox) return;
         const bbox = state.rec.bounds.bbox;
         centerX = bbox[0] + (bbox[2] - bbox[0])/2;
         centerY = bbox[1] + (bbox[3] - bbox[1])/2;
      }
      context.commit('MAP_FLY_TO', {
         center: [centerX, centerY],
         zoom: 13
      });
   },
};

// mutations
const mutations = {
   ZONING_SET:(state,{rec})=>{
      state.rec = rec;
   }
};

export default {
   state,
   getters,
   actions,
   mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/zoning.js